import config from 'config';

export const COOKIE_PATH = '/';
export const COOKIE_DOMAIN = config.cookieDomain;

export const COOKIE_CONSENT = 'wtr_cookie_consent';
export const COOKIE_ADVERTISING = 'wtr_cookies_advertising';
export const COOKIE_ANALYTICS = 'wtr_cookies_analytics';
export const COOKIE_FUNCTIONAL = 'wtr_cookies_functional';

export const thirtyDaysInMilliseconds = 30 * 24 * 60 * 60 * 1000;
